import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { CategoryApi } from '../../../../api/category/category.api';
import { RootState } from '../../../../store/store';
import { checkPermission } from '../../../../utils/app.utils';

const ManageState = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_NEWS_CATEGORIES_MANAGEMENT', permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [id_category, set_id_category] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<{ category_name: string }>({
        category_name: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_category(null);
        set_form({ category_name: "" })
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_complaints_type", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อหมวดหมู่ข่าว")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            category_name,
            created_by,
            created_date,
            modified_date,
            modified_by,
            id_category

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: category_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => {
                                setShowModal('VIEW');
                                set_form(objData)
                                set_id_category(id_category)
                            }}
                            onEditClick={() => {
                                setShowModal('EDIT');
                                set_form(objData)
                                set_id_category(id_category)
                            }}
                            onDeleteClick={() => handleDeleteList(id_category)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleDeleteList = (id_category: number) => {
        alertActive(t("ลบหมวดหมู่ข่าว"), t("ต้องการลบหมวดหมู่ข่าว ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await CategoryApi.delete(id_category).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบหมวดหมู่ข่าว"), t("ลบหมวดหมู่ข่าว เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบหมวดหมู่ข่าว"), t("ลบหมวดหมู่ข่าว ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await CategoryApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.data?.items || []);
                setTotalItems(res.data?.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    // const handleDownloadReport = async () => {
    //     let query: complaintReport = {}
    //     if (search) query = { ...query, keyword: search }
    //     dispatch(setLoading());
    //     await ReportApi.complaintTypeReport(query).then((res) => {
    //         if (res.status < 300) {
    //             const data = res.data;
    //             const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    //             saveAs(blob_file, t("COMPLAINTS_MANAGE_CATEGORY"))
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //         alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    // const handleGetOneDetail = async (id_complaints_type: number, mode: string) => {
    //     setShowModal(mode);
    //     set_id_complaints_type(id_complaints_type)
    //     dispatch(setLoading());
    //     await ComplaintTypeApi.(id_complaints_type).then((res) => {
    //         if (res.status < 300) {
    //             set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: res.data?.data?.complaints_type_name }))
    //         }
    //     }).catch((err) => console.log(err)).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_category) {
            await CategoryApi.update(id_category, { category_name: form.category_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขหมวดหมู่ข่าว"), t('แก้ไขหมวดหมู่ข่าว เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขหมวดหมู่ข่าว"), t("แก้ไขหมวดหมู่ข่าว ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await CategoryApi.create({ category_name: form.category_name }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("สร้างหมวดหมู่ข่าว"), t("สร้างหมวดหมู่ข่าว เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("สร้างหมวดหมู่ข่าว"), t("สร้างหมวดหมู่ข่าว ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        id_category,
        set_id_category,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        checkPermit
    }
}

export default ManageState
